// The hand-off between /onboarding and checkout: someone who leaves onboarding to buy always-on
// must land back on their next step (create the always-on connection), not on a generic page.

const KEY = 'bt-onboarding-upgrade-pending-v1';
const TTL_MS = 24 * 60 * 60 * 1000;

export type UpgradeSource = 'paywall' | 'done_upsell';

export function markUpgradePending(source: UpgradeSource, now = Date.now()): void {
  try { window.localStorage.setItem(KEY, JSON.stringify({ source, at: now })); } catch { /* storage blocked */ }
}

/** The pending upgrade (if it is recent), without clearing it. */
export function readUpgradePending(now = Date.now()): { source: UpgradeSource; at: number } | null {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw);
    if (!v || typeof v.at !== 'number' || now - v.at > TTL_MS) return null;
    return v;
  } catch { return null; }
}

export function clearUpgradePending(): void {
  try { window.localStorage.removeItem(KEY); } catch { /* storage blocked */ }
}

/** Where the post-checkout "Get started" goes: back into onboarding when it sent them. Consumes
 *  the marker (it travels on in the URL), so a later, unrelated purchase never re-routes here. */
export function postCheckoutPath(now = Date.now()): string {
  const pending = readUpgradePending(now);
  clearUpgradePending();
  return pending ? `/onboarding?from=checkout&src=${pending.source}` : '/calendar';
}
